import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TabBar from 'react/containers/layout/tabs/TabBar.js';
import Tab from 'react/containers/layout/tabs/Tab';
import actions from 'react/api/actions';

class Tabs extends Component {

  static propTypes = {
    onClose: PropTypes.func,
    onExpand: PropTypes.func,
    onSelect: PropTypes.func,
    onResize: PropTypes.func,
    updateTitle: PropTypes.func,
    onSort: PropTypes.func,
    defaultTag: PropTypes.any,
    tabs: PropTypes.object,
    tags: PropTypes.object,
  }

  UNSAFE_componentWillMount() {
    window.GreenmileTabPanel = this;
    const { defaultTag, onResize, accessDeniedTag } = this.props;
    this.accessDeniedTag = accessDeniedTag || Tab;
    this.defaultTag = defaultTag || Tab;
    window.addEventListener('resize', () => {
      const showNav = this.scrolled.scrollWidth > this.scrolled.clientWidth;
      onResize({ showNav });
    });
  }

  shouldComponentUpdate(nextProps) {
    const { tabs } = this.props;
    return !(
      tabs.get('list').toOrderedMap().equals(nextProps.tabs.get('list').toOrderedMap()) &&
      tabs.equals(nextProps.tabs)
    );
  }

  componentDidUpdate = () => {
    const showNav = this.scrolled.scrollWidth > this.scrolled.clientWidth;
    const { tabs, onResize } = this.props;
    if (showNav !== tabs.get('showNav')) {
      onResize({ showNav });
    }
  }

  onSelect = tab => (this.props.onSelect(tab))

  getActiveTab = () => {
    const active = this.props.tabs.get('active');
    return (active) ? active.get('key') : '';
  }

  isScreenAllowed = (path) => {
    const pathMatched = path.match(/\/(\w+)/g);
    return pathMatched ? Monet.Session.Security.screens.indexOf(pathMatched[0]) !== -1 : true;
  };

  createPanel = (tab) => {
    const { tabs, tags, updateTitle, configuration } = this.props;
    const activeTabKey = tabs.getIn(['active', 'key']);
    const iframeTag = tags.Iframe;
    const customTag = tags[(tab.tag || tab.key)];
    const menu = configuration.menusOrderedByUrl?.[tab.key || tab.tag] || {};
    const tag = !this.isScreenAllowed(tab.pathname) ? this.accessDeniedTag : ((menu.iframeUrl && iframeTag) || (customTag || this.defaultTag));
    const active = (activeTabKey === tab.key);
    const props = {
      key: `tab-${tab.key}`,
      tab,
      active,
      updateTitle,
      src: menu.iframeUrl,
    };

    return (
      React.createElement(tag, props, <div id={tab.key} />)
    );
  }

  scrollTo = (direction) => {
    const visibleArea = this.scrolled.clientWidth;
    const actualPosition = this.scrolled.scrollLeft;
    if (direction === 'next') {
      this.scrolled.scrollLeft = actualPosition + visibleArea;
    }
    if (direction === 'previous') {
      this.scrolled.scrollLeft = actualPosition - visibleArea;
    }
  }

  render() {
    const { tabs, tags, onClose, onExpand, onSort, onResize } = this.props;
    const panels = tabs.get('list').toList().toJS().map(this.createPanel);
    const ref = scrolled => (this.scrolled = scrolled);
    return (
      <div className="reactivo-tabs gmTabs is-upgraded">
        <TabBar
          scrollTo={this.scrollTo}
          scrolledRef={ref}
          onResize={onResize}
          onMove={onSort}
          onSelect={this.onSelect}
          tabs={tabs}
          tags={tags}
          onClose={onClose}
          onExpand={onExpand}
        />
        {panels}
      </div>
    );
  }
}

Tabs.propTypes = {
  configuration: PropTypes.object
};

Tabs.defaultProps = {
  configuration: {}
};

export default connect(
  ({ tabs, configuration }) => ({ tabs, configuration }),
  actions.tabs.mapDispatchToProps,
)(Tabs);
